import { Dispatch, SetStateAction, useState } from "react";
import discountShape from "../../../assets/images/icons/discount-shape.svg";
import trash from "../../../assets/images/icons/trash-red.svg";
import TextInput from "../../../utils/component/textInput/textInput.index";
import { post, responseValidator } from "../../../scripts/api";
import API from "../../../urls/api";
import { VoucherStatusEnum, VoucherType } from "./ConfirmPlan.index";

const VoucherPlan = ({
    setVoucher,
    voucher,
    plan_id,
    onSuccessVoucer,
    activeVoucher
}: {
    setVoucher: Dispatch<SetStateAction<string>>;
    voucher: string;
    plan_id: string;
    onSuccessVoucer: (voucher: VoucherType | undefined) => void;
    activeVoucher?: VoucherType;
}) => {
    const [error, setError] = useState("");

    const handleValidateVoucher = () => {
        post(
            (data, status) => {
                if (responseValidator(status)) {
                    onSuccessVoucer({
                        amount: data.type === VoucherStatusEnum.PERCENT ? data.amount : data.amount / 10,
                        status: data.type,
                        code: voucher
                    });
                } else {
                    setError(data.detail);
                }
            },
            API.newVoucher.validate(),
            { plan_id, new_voucher_code: voucher }
        );
    };

    return (
        <div className="w-full flex flex-col p-6 bg-white rounded-lg lg:col-span-2">
            <div className="flex items-center gap-4 justify-between mb-5">
                <div className="flex items-center justify-start gap-3">
                    <img src={discountShape} className="[&>*]:size-full size-6 flex items-center justify-center" />
                    <p className="text-primary-600 font-medium">کد تخفیف</p>
                </div>
                {activeVoucher && (
                    <div
                        className="flex items-center justify-start gap-2 cursor-pointer"
                        onClick={() => {
                            onSuccessVoucer(undefined);
                            setVoucher("");
                        }}
                    >
                        <img src={trash} className="[&>*]:size-full size-5 flex items-center justify-center" />
                        <p className="text-red-600 text-[15px]">حذف کد</p>
                    </div>
                )}
            </div>

            <TextInput
                value={voucher}
                onChange={(value) => {
                    setVoucher(value);
                    setError("");
                    onSuccessVoucer(undefined);
                }}
                inputClassName={`text-right !pl-[80px] ${error ? "!border-red-500" : ""}`}
                placeholder=".کد هدیه را وارد کنید"
                error={error}
                endContent={
                    activeVoucher ? (
                        <svg className="ml-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z"
                                fill="#65A30D"
                            />
                        </svg>
                    ) : (
                        <button
                            onClick={handleValidateVoucher}
                            disabled={!voucher}
                            className="text-primary-600 font-bold disabled:text-[#D4D4D4] pl-6 pr-4"
                        >
                            اعمال
                        </button>
                    )
                }
            />
            {activeVoucher && (
                <p className="text-lime-700 text-sm mt-1">{`${activeVoucher.status === VoucherStatusEnum.PERCENT ? activeVoucher.amount : activeVoucher.amount.toLocaleString()} ${activeVoucher.status === VoucherStatusEnum.PERCENT ? "درصد" : "تومان"} تخفیف اعمال شد.`}</p>
            )}
        </div>
    );
};

export default VoucherPlan;
